(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["field-journal"] && !Shopify.designMode) return;
  try {
    
  function initialiseJournal(root) {
    if (root.dataset.ready) return;
    const links = [...root.querySelectorAll('[data-topic]')];
    const cards = [...root.querySelectorAll('[data-entry]')];
    const status = root.querySelector('[data-status]');
    if (!links.length || !status) return;
    root.dataset.ready = 'true';
    links.forEach(link => link.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const topic = link.dataset.topic;
      const matches = cards.filter(card => topic === 'all' || card.dataset.topics.trim().split(/\s+/).includes(topic));
      if (topic !== 'all' && !matches.length) return;
      event.preventDefault();
      cards.forEach(card => { card.hidden = !matches.includes(card); });
      links.forEach(item => { if (item === link) item.setAttribute('aria-current', 'true'); else item.removeAttribute('aria-current'); });
      status.textContent = `${topic === 'all' ? status.dataset.allLabel : link.textContent.trim()} · ${matches.length}`;
      const empty = root.querySelector('[data-empty]');
      if (empty) empty.hidden = matches.length > 0;
    }));
  }
  document.querySelectorAll('[data-journal]').forEach(initialiseJournal);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-journal]').forEach(initialiseJournal));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["field-manuals"]) return;
  try {
    
  if (!customElements.get('field-manuals')) {
    customElements.define('field-manuals', class extends HTMLElement {
      connectedCallback() {
        if (this.onSearch) return;
        this.onSearch = () => {
          const search = this.querySelector('[data-manual-search]').value.trim().toLocaleLowerCase();
          let visible = 0;
          this.querySelectorAll('.field-manual-group').forEach(group => {
            let groupVisible = 0;
            group.querySelectorAll('[data-manual-item]').forEach(item => {
              const match = item.textContent.toLocaleLowerCase().includes(search);
              item.hidden = !match;
              if (match) groupVisible += 1;
            });
            group.hidden = groupVisible === 0;
            visible += groupVisible;
          });
          this.querySelector('[data-manual-empty]').hidden = visible > 0;
        };
        this.addEventListener('input', this.onSearch);
      }
      disconnectedCallback() { this.removeEventListener('input', this.onSearch); this.onSearch = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
